import { render, staticRenderFns } from "./PcNavBar.vue?vue&type=template&id=45665ea4&scoped=true&"
import script from "./PcNavBar.vue?vue&type=script&lang=js&"
export * from "./PcNavBar.vue?vue&type=script&lang=js&"
import style0 from "./PcNavBar.vue?vue&type=style&index=0&id=45665ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45665ea4",
  null
  
)

export default component.exports